import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { TextureType } from './parser/propTypes';
import { makeHTMLId } from './GradientProp';
import { PropComponentProps, PropLayout } from './propComponents';

// draw an ImageBitmap to a canvas, and limit canvas width and height
function drawImage(image: ImageBitmap, canvas: HTMLCanvasElement, maxWidth: number, maxHeight: number) {
  const aspectRatio = image.width / image.height;
    let width, height;
    if(aspectRatio > (maxWidth / maxHeight)) {
      width = maxWidth;
      height = width / aspectRatio;
    } else {
      height = maxHeight;
      width = height * aspectRatio;
    }
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    ctx?.drawImage(image, 0, 0, width, height);
}

export function TexturePicker(props: PropComponentProps) {
  // <input type="file"> element
  const fileInput = useRef<HTMLInputElement | null>(null);
  // canvas image preview element
  const canvas = useRef<HTMLCanvasElement | null>(null);
  const htmlId = useMemo(() => makeHTMLId(), []);
  const { value, setValue } = props;
  const val = value.value as TextureType;

  // handle an uploaded file:
  const handleFile = useCallback(() => {
    // don't do anything if no files have been uploaded
    if(fileInput.current === null
      || fileInput.current.files === null 
      || fileInput.current.files.length < 1) {
      return;
    }
    // load image data from file
    createImageBitmap(fileInput.current.files[0]).then(resp => {
      setValue({ value: { image: resp }, forceConst: value.forceConst });
    });
  }, [setValue, value.forceConst]);

  // preview the image (if present)
  useEffect(() => {
    if(val.image === null || canvas.current === null) return;
    drawImage(val.image, canvas.current, 200, 150);
  }, [val, canvas]);

  return (
    <PropLayout {...props}>
      <div className="fileInputPreview">
        <canvas ref={canvas} width="0" height="0"/>
      </div>
        <label className="fileInputButton" htmlFor={htmlId}>Upload Image</label>
        <input 
          id={htmlId} type="file" accept="image/x-png,image/gif,image/jpeg"
          ref={fileInput} onChange={handleFile}
        />
    </PropLayout>
  );
}